





















































































































import { Component, Vue } from 'vue-property-decorator';
import { setToken, setLocale, getLocale, getSchoolInfo } from '@/utils/utils';
import { LoginController, DropDownController, SchoolController } from '@/services/request.service';
import ApplicationNotesModal from '@/components/ApplicationNotesModal.vue';
import { DropDownResponse } from '@/services/__model';
import config from '@/school.config';

@Component({
  components: {
    ApplicationNotesModal,
  },
})
export default class Login extends Vue {
  public mobileLoginForm: any;
  public verifyCodeTimer = 0;
  public verifyLoading = false;
  public loginLoading = false;
  public schoolVisible = false;
  public schoolList: any = [];
  public selectedSchoolId: any = 0;
  public areaCodeKey: number = 1;
  public areaCode: string = '86';
  public logoUrl: any = '';
  public countryWithCode: Array<DropDownResponse> = [];
  public schoolName: string = '';
  public config = config;

  public get locale(): string {
    return this.$i18n.locale;
  }

  public beforeCreate(): void {
    this.mobileLoginForm = this.$form.createForm(this);
  }

  public created(): void {
    this.schoolName = getSchoolInfo().shortName;
    this.getCountryWithCodeList();
    this.getLogo();
  }

  public changeLocale(language: string): void {
    const currentLocale = this.$i18n.locale;
    if (currentLocale === 'zh' && language !== 'zh') {
      this.$i18n.locale = 'en';
      this.$store.commit('changeLocale', 'en');
      setLocale('en');
    } else if (currentLocale === 'en' && language !== 'en') {
      this.$i18n.locale = 'zh';
      this.$store.commit('changeLocale', 'zh');
      setLocale('zh');
    }
  }

  public getCountryWithCodeList(): void {
    DropDownController.getCountryWithCodeList()
      .then((res: any) => {
        this.countryWithCode = res && res.data ? res.data : [];
      })
      .catch((err: any) => {});
  }

  public handlePhoneOfCountryChange(value: number): void {
    this.areaCodeKey = value ? value : 1;
    const res: any = this.countryWithCode.filter(item => item.key === value);
    if (res.length > 0) {
      this.areaCode = res[0].extraValue;
    }
  }

  public sendVerifyCode(): void {
    const mobile = this.mobileLoginForm.getFieldValue('mobile');
    if (mobile) {
      this.verifyLoading = true;
      LoginController.sendVerifyCode(mobile, this.areaCode)
        .then((result: any) => {
          if (result) {
            this.$message.success(this.$tc('login.sendVerifyCodeSuccess'));
            this.timerCountDown();
          }
        })
        .catch((err: any) => {})
        .finally(() => {
          this.verifyLoading = false;
        });
    }
  }

  public timerCountDown(): void {
    this.verifyCodeTimer = 120;
    const timer = setInterval(() => {
      this.verifyCodeTimer = this.verifyCodeTimer - 1;
      if (this.verifyCodeTimer === 0) {
        clearInterval(timer);
      }
    }, 1000);
  }

  public confirmNotes(): void {
    const temp: any = localStorage.getItem('tip');
    if (config[this.schoolName].showApplicationNotes && !temp) {
      const formRef: any = this.$refs.confirmModal;
      if (formRef) {
        this.$nextTick(() => {
          formRef.showConfirm();
        });
      }
    } else {
      this.loginSubmit();
    }
  }

  public mobileSubmit(e: Event): void {
    e.preventDefault();
    this.mobileLoginForm.validateFields({ first: true }, (err: any, values: any) => {
      if (!err) {
        const areaCode = this.areaCode;
        const mobile = this.mobileLoginForm.getFieldValue('mobile');
        const vcode = this.mobileLoginForm.getFieldValue('verifyCode');
        const autoLogin = true;
        this.confirmNotes();
      } else {
        this.loginLoading = false;
      }
    });
  }
  public getLogo() {
    SchoolController.getAllSchools().then((res: any) => {
      if (this.config[this.schoolName].schoolId === 1) {
        this.logoUrl = res.data[0].logoUrl;
      }
      if (this.config[this.schoolName].schoolId === 2) {
        this.logoUrl = res.data[1].logoUrl;
      }
      if (this.config[this.schoolName].schoolId === 3) {
        this.logoUrl = res.data[2].logoUrl;
      }
      if (this.config[this.schoolName].schoolId === 4) {
        this.logoUrl = res.data[3].logoUrl;
      }
      if (this.config[this.schoolName].schoolId === 5) {
        this.logoUrl = res.data[4].logoUrl;
      }
      if (this.config[this.schoolName].schoolId === 6) {
        this.logoUrl = res.data[5].logoUrl;
      }
      if (this.config[this.schoolName].schoolId === 7) {
        this.logoUrl = res.data[6].logoUrl;
      }
      if (this.config[this.schoolName].schoolId === 9) {
        this.logoUrl = res.data[7].logoUrl;
      }
    });
    return {};
  }
  public loginSubmit(): void {
    const areaCode = this.areaCode;
    const mobile = this.mobileLoginForm.getFieldValue('mobile');
    const vcode = this.mobileLoginForm.getFieldValue('verifyCode');
    const autoLogin = true;
    this.loginLoading = true;
    LoginController.login({ areaCode, mobile, vcode, autoLogin })
      .then((res: any) => {
        const token = res.data.token;
        setToken(token, autoLogin);
        this.$router.push({ name: 'application' });
      })
      .finally(() => {
        this.loginLoading = false;
      });
  }
}
